import {Injectable} from "@angular/core";
import {ApplicationCatalogActions} from "../Actions/application-catalog-actions";
import {APP_SPEC_STATE_INIT, ISelectorState} from "../selector.state";
import {ApplicationSpecActions} from "../Actions/application-spec-actions";
import {composeEntityAlert, EMPTY_ENTITY_ALERT, reduceEntityAlert} from "../../models/EntityAlert";
import {ISingleOutput, ISpec} from "../../models/ISpec";
import {tassign, Utils} from "../../common/utils";
import {isNull} from "util";
import {IEntityAlert} from "../../models/common";
import {from, of} from "rxjs";
import {filter, mergeMap} from "rxjs/operators";
import {ActionLocal} from "../Actions/actions.service";
import {ofType} from "redux-observable-es6-compat";


@Injectable()
export class ValidationSpecsEpics {
  private _maxNumOutput: number;
  private _minNumOutput: number;

  private get minNumOutputs(): number {
    return Math.max(1, this._minNumOutput);
  }

  private get maxNumOutputs(): number {
    return Math.max(this.minNumOutputs, this._maxNumOutput);
  }

  private getGlobalAlert(a: ISpec<IEntityAlert>): IEntityAlert {

    return reduceEntityAlert(
      composeEntityAlert([
        a.input.min,
        a.input.max,
        a.input.freq,
        a.specValidation,
        a.output.outputs.reduce((acc: IEntityAlert, curr: ISingleOutput<IEntityAlert>) =>
          composeEntityAlert([acc, curr.voltage, curr.current, curr.power]), EMPTY_ENTITY_ALERT),
        a.output.globalOutput.voltage,
        a.output.globalOutput.current,
        a.output.globalOutput.power,
        a.output.ledParam.serial,
        a.output.ledParam.parallel,
        a.output.ledParam.rd,
      ]));
  }

  constructor() {
  }

  listeningValidateActions = (action$) => {
    const actionsToRefresh: string[] = [
      ApplicationCatalogActions.ActionType.SELECT_SOLUTION,
      // The validation will be performed only after order_solution and set design solution
      // ApplicationSpecActions.ActionType.INPUT_SET_VALUE,
      // ApplicationSpecActions.ActionType.OUTPUT_ADD,
      // ApplicationSpecActions.ActionType.OUTPUT_REMOVE,
      // ApplicationSpecActions.ActionType.OUTPUT_SET_VALUE,
      // ApplicationSpecActions.ActionType.SINGLE_OUTPUT_SET_VALUE,
      // ApplicationSpecActions.ActionType.RESET_SPECS,
    ];

    return action$.pipe(
      filter((x: ActionLocal) => actionsToRefresh.includes(x.type)),
      mergeMap(() => {
//        console.log("Refresh");
        return of(ApplicationSpecActions.validateSpecs());
      })
    );
  }


  validateSpecs = (action$, store) => {
    return action$.pipe(
      ofType(ApplicationSpecActions.ActionType.VALIDATE_SPECS),
      // .debounceTime(100)            //TODO to check
      mergeMap(() => {

        const _selectedSolution = store.value.appCatalog.selectedSolution;
        const _specValue = store.value.appSpec.spec.value;
        const _validateFn = store.value.appCatalog.service.validatorCreator;

        const tempGlobalSpec = tassign(APP_SPEC_STATE_INIT, {spec: {value: _specValue}});
        this._maxNumOutput = 6;
        this._minNumOutput = 1;

        if (!isNull(_selectedSolution)) {
          this._maxNumOutput = Utils.getFieldValue(_selectedSolution, 'designData.maxNumOutput', 1);
          this._minNumOutput = Utils.getFieldValue(_selectedSolution, 'designData.minNumOutput', 1);
        }

        const specNote: ISpec<IEntityAlert> = _validateFn(_selectedSolution).validate(_selectedSolution, tempGlobalSpec);
        const globalNote: IEntityAlert = this.getGlobalAlert(specNote);

        return from([
          ApplicationSpecActions.updateOutputsBoundsSpec({min: this.minNumOutputs, max: this.maxNumOutputs}),
          ApplicationSpecActions.setGlobalNote(specNote, globalNote)]);
      })
    );
  }
}


